import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
//import { saveTrader, getTraders } from '../../Api';
import moment from 'moment'; //Both are required here
import useApi from '../../api/useApi';
import useQueryParams from '../../context/useQueryParams';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const PooledLotView = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const _auctionId = queryParams.get('a');
    const [auctionId, setAuctionId] = useState(_auctionId);

    const api = useApi();
    const [traders, setTraders] = useState([]);

    const containsPooledLotDetail = location.pathname.includes('pooledLotDetail');

    const [formData, setFormData] = useState({
        pooledLotId: 0,
        lotNumber: null,
        collectionCenter: '',
        planterDealer: 1,
        planterName: '',
        planterId: 0,
        crnosblNo: '',
        quantityKg: 0.0,
        litreWeightGms: 0.0,
        bags: null,
        gradeType: '',
        grade: '',
        reservedPrice: null,
        auctionStartPriceRs: null,
        immatureSeeds: null,
        moistureContent: null,
        planterMobileNumber: '',
        size: '',
        colour: '',
        rejection: '',
        isSpecialLot: false,
        cropReceiptNumber: '',
    });
    const [isPoolingClosed, setIsPoolingClosed] = useState(false);
    const { parameters } = useQueryParams();

    const getPooledLotDetail = async () => {
        try {
            const lotDetail = await api.getPooledLotDetailForAuctionAdmin(id);

            const formattedData = {
                auctionId: lotDetail.auctionId,
                pooledLotId: lotDetail.pooledLotId,
                lotNumber: lotDetail.lotNumber,
                poolLotNumber: lotDetail.poolLotNumber,
                collectionCenter: lotDetail.collectionCenter,
                planterDealer: lotDetail.planterDealer,
                planterName: lotDetail.planterName,
                crnosblNo: lotDetail.crnosblNo,
                quantityKg: lotDetail.quantityKg,
                litreWeightGms: lotDetail.litreWeightGms,
                bags: lotDetail.bags,
                bagWeight: lotDetail.bagWeight,
                gradeType: lotDetail.gradeType,
                grade: lotDetail.grade,
                reservedPrice: lotDetail.reservedPrice,
                auctionStartPriceRs: lotDetail.auctionStartPriceRs,
                immatureSeeds: lotDetail.immatureSeeds,
                moistureContent: lotDetail.moistureContent,
                planterMobileNumber: lotDetail.planterMobileNumber,
                size: lotDetail.size,
                colour: lotDetail.colour,
                rejection: lotDetail.rejection,
                isSpecialLot: lotDetail.isSpecialLot,
                specialLotRemark: lotDetail.specialLotRemark,
                cropReceiptNumber: lotDetail.cropReceiptNumber,
                isProvisionalCropReceipt: lotDetail.isProvisionalCropReceipt,
                bankAcNo: lotDetail.bankAcNo,
                ifscCode: lotDetail.ifscCode,
            };
            setFormData(formattedData);
            if (lotDetail?.isPoolingClosed === true)
                setIsPoolingClosed(true);


            loadTraders();

        } catch (error) {
            alert('Unable to fetch pooled lot data.');
        }
    };

    useEffect(() => {
        if (id > 0)
            getPooledLotDetail();
        else {
            loadTraders();
            setFormData({ collectionCenter: parameters.poolingCenterName });
        }
    }, []);


    useEffect(() => {
        updatePlanterDealer();
    }, [formData, traders]);


    const updatePlanterDealer = () => {

        if (traders.length > 0) {
            const selectedTrader = traders.find(t => t.bidderName === formData.planterName);

            if (parseInt(formData.planterDealer) === 2 && selectedTrader && formData.planterId !== selectedTrader.traderId) {
                if (selectedTrader) {
                    setFormData({
                        ...formData,
                        planterId: selectedTrader.traderId,
                    });
                }
            }
        }
    }

    const loadTraders = async () => {
        try {
            const _traders = await api.getPoolingTraders();

            setTraders(_traders);

        } catch (error) {
            alert('Unable to fetch traders data.');
        }
    };

    const handlePlanterChange = (event) => {
        const value = event.target.value;
        setFormData({
            ...formData,
            planterDealer: value,
            planterName: "",
            planterMobileNumber: "",
            crnosblNo: ""
        });
    };

    const handlePlanterNameChange = (event) => {
        const value = event.target.value;
        if (traders) {
            const selectedTrader = traders.find(t => t.traderId === parseInt(value));
            setFormData({
                ...formData,
                planterName: selectedTrader.bidderName,
                planterId: selectedTrader.traderId,
                planterMobileNumber: selectedTrader.mobileNo,
                crnosblNo: selectedTrader.licenceNumber
            });
        }
        else {
            setFormData({
                ...formData,
                planterName: value,
            });
        }
    };


    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.name === "isSpecialLot" ? (e.target.value === "true" ? true : false) : e.target.value,
        });
    };

    const handleMobileNumberChange = (e) => {
        const value = e.target.value;
        if (value.length <= 10) {
            setFormData({
                ...formData,
                planterMobileNumber: value,
            });
        }
    };

    const handleSBLChange = (e) => {
        const value = e.target.value;
        if (value.length <= 30) {
            setFormData({
                ...formData,
                crnosblNo: value,
            });
        }
    };


    const handleBagChange = (e) => {
        const value = e.target.value;
        if (value.length <= 3) {
            setFormData({
                ...formData,
                bags: value,
            });
        }
    };


    const handleQuantityChange = (e) => {
        const value = e.target.value;
        if (value <= 9999.999) {
            setFormData({
                ...formData,
                quantityKg: value,
            });
        }
    };

    const handleLiterWeightChange = (e) => {
        const value = e.target.value;
        if (value <= 9999.999) {
            setFormData({
                ...formData,
                litreWeightGms: value,
            });
        }
    };

    const handleReservedPrice = (e) => {
        const value = e.target.value;
        if (value <= 99999.999) {
            setFormData({
                ...formData,
                reservedPrice: value,
            });
        }
    };
    const handleAuctionStartPrice = (e) => {
        const value = e.target.value;
        if (value <= 99999.999) {
            setFormData({
                ...formData,
                auctionStartPriceRs: value,
            });
        }
    };

    const handlePoolLotNumberChange = (event) => {
        const value = event.target.value;
        const numericPart = value.replace(/^R/, '').replace(/\D/g, '');

        setFormData({ ...formData, poolLotNumber: numericPart });
    };


    const goBack = () => {
        navigate(-1);
    }

 
    const downloadCropReceipt = async () => {

        const receiptData = await api.getCropReceipt(id);
        let rows = [];
        if (receiptData.isProvisionalCropReceipt === true)
            rows.push([{ text: "PROVISIONAL CROP RECEIPT", colSpan: 2, fontSize: 20, bold: true }, { text: "" }]);
        else
            rows.push([{ text: "CROP RECEIPT", colSpan: 2, fontSize: 20, bold: true }, { text: "" }]);

        rows.push([{ text: "Receipt No. " + receiptData.cropReceiptNumber, border: [true, false, false, true] }, { text: "Receipt Date : " + moment(receiptData.poolingDate).format('DD-MMM-YYYY'), alignment: "right", border: [false, false, true, true] }]);
        rows.push([{ text: "", colSpan: 2, margin: [0, 5, 0, 5] }, { text: "" }]);
        rows.push([{ text: "POOLING DETAIL", bold: true, colSpan: 2, fillColor: "#a2bbdb" }, { text: "" }]);
        rows.push([{ text: "Name Of Planter / Dealer / Contact No : " }, { text: receiptData.planterName + " / " + receiptData.planterMobileNumber, bold: true }]);
        rows.push([{ text: "Pooling Centre : " }, { text: receiptData.centerName, bold: true }]);
        rows.push([{ text: "Date of Pooling : " }, { text: moment(receiptData.poolingDate).format('DD-MMM-YYYY'), bold: true }]);
        rows.push([{ text: "CRNO/SBL No : " }, { text: receiptData.crnosblNo, bold: true }]);
        rows.push([{ text: "Lot Number : " }, { text: receiptData.lotNumber, bold: true }]);
        rows.push([{ text: "Number of bags : " }, { text: receiptData.bags, bold: true }]);
        rows.push([{ text: "Net Weight : " }, { text: receiptData.quantityKg + " kg", bold: true }]);
        rows.push([{ text: "Litre weight : " }, { text: receiptData.litreWeightGms + " gram", bold: true }]);
        rows.push([{ text: "", colSpan: 2, margin: [0, 5, 0, 5] }, { text: "" }]);
        rows.push([{ text: "AUCTIONEER DETAIL", bold: true, colSpan: 2, fillColor: "#a2bbdb" }, { text: "" }]);
        rows.push([{ text: "Auctioneer : " + receiptData.companyName, colSpan: 2 }, { text: "" }]);
        rows.push([{ text: "License No : " + receiptData.licenceNumber }, { text: "GST No : " + receiptData.gstNumber }]);
        rows.push([{ text: "Auction No. : " + receiptData.auctionNo }, { text: "Auction Date : " + moment(receiptData.auctionDate).format('DD-MMM-YYYY') }]);
        rows.push([{ text: "Payment Due Date : 10 days from the date of auction." }, { text: "" }]); //+ moment(receiptData.paymentDueDate).format('DD-MMM-YYYY')
        rows.push([{ text: "", colSpan: 2, margin: [0, 5, 0, 5], border: [true, false, true, false] }, { text: "" }]);
        rows.push([{ text: "The Cardamom pooled with us will be sold through our auction subject to the terms and conditions of the Cardamom Auctioneer Licence issued by Spice Board. This Crop Receipt should be produced when claiming payment.", border: [true, false, true, false], colSpan: 2 }, { text: "" }]);
        rows.push([{ text: "Declaration : Sealed sample handed over to Planter / Dealer.", border: [true, false, true, false], colSpan: 2 }, { text: "" }]);
        rows.push([{ text: "", colSpan: 2, margin: [0, 30, 0, 30], border: [true, false, true, false] }, { text: "" }]);
        rows.push([{ text: "Customer Signature", alignment: "center", border: [true, false, false, false] }, { text: "Authorized Signatory", alignment: "center", border: [false, false, true, false] }]);
        //rows.push([{ text: "Sample taken: 3 Kg\nPayment will be made for : (" + receiptData.quantityKg + "kg - 200gm) = " + ((receiptData.quantityKg * 1000) - 200) / 1000 + " Kg", fontSize: 10, margin: [0, 10, 0, 10], colSpan: 2, border: [true, false, true, true] }, { text: "" }]);
        rows.push([{ text: "Sample taken: 3 Kg\nIf the lot is sold : Payment will be made for : (" + receiptData.quantityKg + "kg - 150gm) = " + (receiptData.quantityKg - 0.15) + " Kg.\nIf the lot is withdrawn before bidding : Whole sample will be returned.\nIf the lot is withdrawn after bidding : Payment will be made for 3000 gm based on the average price of that auction or return the sample in the form of cardamom mixed with other samples.\nIf the lot is detected with artificial colour, 2900 gm sample will be returned.", fontSize: 10, margin: [0, 10, 0, 10], colSpan: 2, border: [true, false, true, true] }, { text: "" }]);
        rows.push([{ text: "Software by Boltware | www.boltware.in", fontSize: 6, margin: [0, 20, 0, 20], colSpan: 2, border: [false, false, false, false] }, { text: "" }]);


        let body = rows;
        const documentDefinition = {
            content: [
                {
                    style: 'tableExample2',
                    table: {
                        //widths: [222,222],
                        body: body
                    }, layout: {
                        paddingLeft: (i, node) => 5,
                        paddingRight: (i, node) => 5,
                        paddingTop: (i, node) => 5,
                        paddingBottom: (i, node) => 5
                    }
                },
            ],
            styles: {
                tableExample2: {
                    width: '100%',
                    fontSize: 10, // Set the font size for the table
                },
            }
        };
        let filename = "Crop-Receipt-" + receiptData.cropReceiptNumber + ".pdf"
        pdfMake.createPdf(documentDefinition).download(filename);
    }

    return (
        <div className="inner-body">
            <div className="page-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Pooled Lot Detail</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a className="custom-link" onClick={() => navigate(-1)}>Home</a></li>
                    </ol>
                </div>
                <div className="d-flex">

                </div>
            </div>
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12">
                    <div className="card custom-card">

                        <form>
                            <div className="card-body pd-l-40">
                                <div className=" mg-b-10 pb-10">
                                    <cite className="text-muted">Lot number & collection center are automatically updated after save.</cite>
                                </div>
                                <div className="row row-xs mg-b-4">
                                    <div className="col-md-2">
                                        <label className="mg-t-8">Auto Generated Sequence No.  </label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="text" name="lotNumber" disabled className="form-control med-height" value={formData.lotNumber} />
                                    </div>
                                    <div className="offset-md-1 col-md-2">
                                        <label className="mg-t-8">Collection Centre</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="text" name="collectionCenter" disabled className="form-control med-height" value={formData.collectionCenter} />
                                    </div>
                                </div>
                                <div className="row row-xs mg-b-4">
                                    <div className="col-md-2">
                                        <label className="mg-t-8">Pooled Lot Number <span className="text-danger">*</span></label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="text" name="poolLotNumber" maxLength="4" disabled className="form-control med-height" onChange={handlePoolLotNumberChange} value={`R${formData.poolLotNumber || ''}`} />
                                    </div>
                                    {/*<div className="offset-md-1 col-md-2">*/}
                                    {/*    <label className="mg-t-8">Collection Centre</label>*/}
                                    {/*</div>*/}
                                    {/*<div className="col-md-3 mg-t-5 mg-md-t-0">*/}
                                    {/*    <input type="text" name="collectionCenter" disabled className="form-control med-height" value={formData.collectionCenter} />*/}
                                    {/*</div>*/}
                                </div>
                                <div className="row row-xs mg-b-4">
                                    <div className="col-md-2">
                                        <label className="mg-t-8">Planter/Dealer</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <select name="planterDealer" className="form-control med-height" disabled onChange={handlePlanterChange} value={formData.planterDealer} >
                                            <option value="1">Planter</option>
                                            <option value="2">Dealer</option>
                                        </select>
                                    </div>
                                    <div className="offset-md-1 col-md-2">
                                        <label className="mg-t-8">Planter/Dealer Name </label>
                                    </div>
                                    {parseInt(formData.planterDealer) === 2 ?
                                        <div className="col-md-3 mg-t-5 mg-md-t-0">
                                            <select name="planterName" className="form-control med-height" disabled onChange={handlePlanterNameChange} value={formData.planterId} >
                                                {traders.map(t => {
                                                    return <option value={t.traderId}>{t.bidderName}</option>
                                                })}
                                            </select>
                                        </div> : <div className="col-md-3 mg-t-5 mg-md-t-0">
                                            <input type="text" name="planterName" className="form-control med-height" disabled onChange={handleInputChange} value={formData.planterName} />
                                        </div>
                                    }
                                </div>
                                <div className="row row-xs mg-b-4">
                                    <div className="col-md-2">
                                        <label className="mg-t-8">Planter Mobile Number</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="number" name="planterMobileNumber" disabled required className="form-control med-height" maxLength="10" minLength="10" onChange={handleMobileNumberChange} value={formData.planterMobileNumber} />
                                    </div>
                                    <div className="offset-md-1 col-md-2">
                                        <label className="mg-t-8">CRNO/SBL No</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="text" name="crnosblNo" className="form-control med-height" disabled required onChange={handleSBLChange} value={formData.crnosblNo} />
                                    </div>
                                </div>
                                <div className="row row-xs mg-b-4">
                                    <div className="col-md-2">
                                        <label className="mg-t-8">Bags</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="number" name="bags" className="form-control med-height" disabled required minLength="1" min="1" onChange={handleBagChange} value={formData.bags} />
                                    </div>
                                    <div className="offset-md-1 col-md-2">
                                        <label className="mg-t-8">Bag Weight (Kg) <span className="text-danger">*</span></label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="number" name="bagWeight" className="form-control med-height" disabled minLength="1" min="1"  value={formData.bagWeight} />
                                    </div>
                                </div>


                                <div className="row row-xs mg-b-4">
                                    <div className="col-md-2">
                                        <label className="">Quantity(Kg)</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="number" name="quantityKg" step="0.01" disabled className="form-control med-height" required onChange={handleQuantityChange} value={formData.quantityKg} />
                                    </div>
                                    <div className="offset-md-1 col-md-2">
                                        <label className="mg-t-8">Litre Weight(Gms)</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="number" name="litreWeightGms" step="0.01"  disabled className="form-control med-height" onChange={handleLiterWeightChange} value={formData.litreWeightGms} />
                                    </div>
                                </div>
                                <div className="row row-xs mg-b-4">
                                    <div className="col-md-2">
                                        <label className="mg-t-8">Grade Type</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="text" name="gradeType" className="form-control med-height" disabled maxLength="5" onChange={handleInputChange} value={formData.gradeType} />
                                    </div>
                                    <div className="offset-md-1 col-md-2">
                                        <label className="mg-t-8">Grade</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="text" name="grade" className="form-control med-height" disabled maxLength="10" onChange={handleInputChange} value={formData.grade} />
                                    </div>
                                </div>
                                <div className="row row-xs mg-b-4">
                                    <div className="col-md-2">
                                        <label className="mg-t-8">Reserved Price</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="number" name="reservedPrice" step="0.01" disabled className="form-control med-height" onChange={handleReservedPrice} value={formData.reservedPrice} />
                                    </div>
                                    <div className="offset-md-1 col-md-2">
                                        <label className="mg-t-8">Auction Start Price(Rs)</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="number" name="auctionStartPriceRs" step="0.01" disabled className="form-control med-height" onChange={handleAuctionStartPrice} value={formData.auctionStartPriceRs} />
                                    </div>
                                </div>

                                <div className="row row-xs mg-b-4">
                                    <div className="col-md-2">
                                        <label className="mg-t-8">Immature Seeds(%)</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="number" name="immatureSeeds" className="form-control med-height" disabled max="100" onChange={handleInputChange} value={formData.immatureSeeds} />
                                    </div>
                                    <div className="offset-md-1 col-md-2">
                                        <label className="mg-t-8">Moisture Content(%)</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="number" name="moistureContent" className="form-control med-height" disabled max="100" onChange={handleInputChange} value={formData.moistureContent} />
                                    </div>
                                </div>

                                <div className="row row-xs mg-b-4">
                                    <div className="col-md-2">
                                        <label className="mg-t-8">Size</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="text" name="size" className="form-control med-height" disabled onChange={handleInputChange} value={formData.size} />
                                    </div>
                                    <div className="offset-md-1 col-md-2">
                                        <label className="mg-t-8">Colour</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="text" name="colour" className="form-control med-height" disabled onChange={handleInputChange} value={formData.colour} />
                                    </div>
                                </div>

                                <div className="row row-xs mg-b-4">
                                    <div className="col-md-2">
                                        <label className="mg-t-8">Rejection/Split</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="text" name="rejection" className="form-control med-height" disabled onChange={handleInputChange} value={formData.rejection} />
                                    </div>
                                    <div className="offset-md-1 col-md-2">
                                        <label className="mg-t-8">Special Lot (Yes/No)</label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <select name="isSpecialLot" className="form-control med-height" disabled onChange={handleInputChange} value={formData.isSpecialLot} >
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </div>
                                </div>
                                {formData.isSpecialLot ?
                                    <div className="row row-xs mg-b-4">
                                        <div className="col-md-2">
                                            <label className="mg-t-8">Special Lot Remark </label>
                                        </div>
                                        <div className="col-md-3 mg-t-5 mg-md-t-0">
                                            <input type="text" name="specialLotRemark" className="form-control med-height" onChange={handleInputChange} value={formData.specialLotRemark} />
                                        </div>
                                    </div> : null}

                                <h6 style={{ borderBottomColor: '#e5e8ee', borderBottomWidth: '1px', borderBottomStyle: "solid", marginTop: '30px', marginBottom: '20px', paddingBottom: '10px' }}>Bank Details</h6>
                                <div className="row row-xs mg-b-4">
                                    <div className="col-md-2">
                                        <label className="mg-t-8">Planter/Dealer Bank A/c Number <span className="text-danger">*</span></label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="text" name="bankAcNo" className="form-control med-height" disabled onChange={handleInputChange} value={formData.bankAcNo} />
                                    </div>
                                    <div className="offset-md-1 col-md-2">
                                        <label className="mg-t-8">IFSC Code <span className="text-danger">*</span></label>
                                    </div>
                                    <div className="col-md-3 mg-t-5 mg-md-t-0">
                                        <input type="text" name="ifscCode" className="form-control med-height" disabled onChange={handleInputChange} value={formData.ifscCode} />
                                    </div>
                                </div>
                                <h6 style={{ borderBottomColor: '#e5e8ee', borderBottomWidth: '1px', borderBottomStyle: "solid", marginTop: '30px', marginBottom: '20px', paddingBottom: '10px' }}></h6>
                                <div className="btn-list mg-t-10 d-flex">
                                    {formData?.pooledLotId > 0 && formData?.isProvisionalCropReceipt === true ?
                                        <button type="button" className=" btn btn-outline-primary" onClick={downloadCropReceipt}>Download Crop Receipt (Provisional)</button>
                                        : null}
                                    {formData?.pooledLotId > 0 && formData?.isProvisionalCropReceipt === false ?
                                        <button type="button" className=" btn btn-outline-primary " onClick={downloadCropReceipt}>Download Crop Receipt </button>
                                        : null}
                                    <button type="button" className=" btn btn-light" onClick={goBack}>Back</button>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    );

};

export default PooledLotView;



